import { render, staticRenderFns } from "./ModattaRadioInput.vue?vue&type=template&id=ad30493a"
import script from "./ModattaRadioInput.vue?vue&type=script&lang=js"
export * from "./ModattaRadioInput.vue?vue&type=script&lang=js"
import style0 from "./ModattaRadioInput.vue?vue&type=style&index=0&id=ad30493a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports